module.exports = __webpack_public_path__ + "img/logo-footer-03.bf59dd7f.jpg";